import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]
  static values = { defaults: Object }

  connect() {
    this.draggedRow = null
    this.serialize()
  }

  dragStart(event) {
    if (event.currentTarget.dataset.locked === "true") {
      event.preventDefault()
      return
    }

    this.draggedRow = event.currentTarget
    this.draggedRow.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    if (!this.draggedRow || event.currentTarget.dataset.locked === "true") return

    event.preventDefault()
    const target = event.currentTarget
    const after = event.clientY > target.getBoundingClientRect().top + target.offsetHeight / 2
    target.parentElement.insertBefore(this.draggedRow, after ? target.nextSibling : target)
  }

  dragEnd() {
    this.draggedRow?.classList.remove("is-dragging")
    this.draggedRow = null
    this.serialize()
  }

  moveUp(event) {
    const row = event.currentTarget.closest("[data-column-key]")
    const previous = row.previousElementSibling
    if (!previous || previous.dataset.locked === "true") return

    row.parentElement.insertBefore(row, previous)
    this.serialize()
  }

  moveDown(event) {
    const row = event.currentTarget.closest("[data-column-key]")
    const next = row.nextElementSibling
    if (!next) return

    row.parentElement.insertBefore(next, row)
    this.serialize()
  }

  reset(event) {
    const listing = event.currentTarget.dataset.listing
    const list = this.listTargets.find((target) => target.dataset.listing === listing)
    const defaults = this.defaultsValue[listing]
    if (!list || !defaults) return

    defaults.order.forEach((key) => {
      const row = list.querySelector(`[data-column-key="${key}"]`)
      if (row) list.appendChild(row)
    })
    list.querySelectorAll("input[type='checkbox']").forEach((checkbox) => { checkbox.checked = true })
    this.serialize()
  }

  serialize() {
    const preferences = {}

    this.listTargets.forEach((list) => {
      const rows = Array.from(list.querySelectorAll("[data-column-key]"))
      preferences[list.dataset.listing] = {
        order: rows.map((row) => row.dataset.columnKey),
        hidden: rows.filter((row) => !row.querySelector("input[type='checkbox']").checked)
          .map((row) => row.dataset.columnKey)
      }
    })

    this.inputTarget.value = JSON.stringify(preferences)
  }
}
